import { AssetManagerInvoiceStatus } from "@shared/types";

export const COLUMN_SPANS = [9, 7, 8];

export const INVOICE_STATUS_TO_DISPLAY = {
  [AssetManagerInvoiceStatus.PENDING]: "Pending",
  [AssetManagerInvoiceStatus.PAID]: "Paid",
  [AssetManagerInvoiceStatus.CANCELED]: "Canceled",
  [AssetManagerInvoiceStatus.REFUNDED]: "Refunded",
  [AssetManagerInvoiceStatus.DELETED]: "Deleted",
};
